import { LocationDesignConfig } from './types'

export const locationDesignConfig: LocationDesignConfig[] = [
  {
    type: 'pistacja',
    isProgressBar: false,
    isTargetAmount: false,
    baseColors: {
      primary: '#96B541',
      primaryLighter: '#ECF4DC',
      secondary: '#009172',
    },
  },
  {
    type: 'default',
    isProgressBar: true,
    isTargetAmount: true,
    baseColors: {
      primary: '#3971FF',
      primaryLighter: '#FF0049',
      secondary: '#6EB0FF',
    },
  },
]
